import {
  AHText,
  Box,
  Circle,
  useLayoutContext,
  useScaleFactor,
  useTheme,
} from "arkh";

import { Logo } from "./Logo";
import QRCode from "react-native-qrcode-svg";
import React from "react";
import { View } from "react-native";
import { FormattedMessage } from "react-intl";

const Instructionitem = (props: {
  num: string;
  text: React.ReactNode;
  detail?: React.ReactNode;
}) => {
  const sf = useScaleFactor();

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
      spaceBottom="large"
    >
      <Circle
        size="large"
        color="surface-cta"
        style={{
          marginRight: 18 * sf,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AHText
          style={{
            textAlign: "center",
            color: "white",
            fontFamily: "poppins-display",
          }}
          color="lightText"
          type="title-small"
        >
          {props.num}
        </AHText>
      </Circle>
      <Box
        style={{
          flex: 1,
        }}
      >
        <AHText
          style={{
            textAlign: "left",
            fontFamily: "poppins-display",
          }}
          type="subtitle"
        >
          {props.text}
        </AHText>
        {props.detail && (
          <AHText
            style={{
              textAlign: "left",
              fontFamily: "poppins-display",
            }}
            type="detail"
          >
            {props.detail}
          </AHText>
        )}
      </Box>
    </Box>
  );
};

export function PollForTokenScreen(props: { userCode: string }) {
  const theme = useTheme();
  const { space } = useLayoutContext();
  const sf = useScaleFactor();

  return (
    <View
      style={{
        flex: 1,
        overflow: "hidden",
        position: "relative",
        height: "100%",
        flexDirection: "row",
      }}
    >
      <Box
        spaceTop="xxlarge"
        style={{
          backgroundColor: "#F4F3F9",
          height: "100%",
          width: "75%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <View style={{ alignItems: "center" }}>
          <Logo color="surface-cta" width={110 * sf} />
          <AHText
            type="title-big"
            spaceTop="large"
            style={{
              fontFamily: "poppins-display",
              fontWeight: "800",
            }}
          >
            <FormattedMessage
              description="Login QR splash screen title"
              defaultMessage="Welcome to StoreSprint!"
            />
          </AHText>
          <AHText
            type="list-item-title"
            spaceTop="medium"
            color="text-secondary"
            style={{
              textAlign: "center",
              width: "50%",
            }}
          >
            <FormattedMessage
              description="Login QR splash screen subtitle"
              defaultMessage="Get started with StoreCast, a natural meeting point and an effective way to distribute essential information!"
            />
          </AHText>
        </View>
        <Box
          style={{
            flex: 1,
            width: "100%",
            paddingTop: 80 * sf,
            paddingBottom: 80 * sf,
            alignItems: "center",
          }}
        >
          <picture
            style={{
              display: "contents",
            }}
          >
            <source
              type="image/webp"
              srcSet={require("../assets/images/QR.webp")}
            />
            <img
              src={require("../assets/images/QR.png")}
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          </picture>
        </Box>
      </Box>
      <Box
        color="surface-primary"
        spaceHorizontal="large"
        spaceVertical="xxlarge"
        style={{
          flex: 1,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Instructionitem
            num="1"
            text={
              <FormattedMessage
                description="Login QR splash screen instruction item 1"
                defaultMessage="Download StoreSprint from App Store or Google Play."
              />
            }
          />
          <Instructionitem
            num="2"
            text={
              <FormattedMessage
                description="Login QR splash screen instruction item 2"
                defaultMessage="Open StoreSprint with your phone or tablet."
              />
            }
          />
          <Instructionitem
            num="3"
            text={
              <FormattedMessage
                description="Login QR splash screen instruction item 3"
                defaultMessage="Click on Store Admin > Screens > Add Screen."
              />
            }
            detail={
              <FormattedMessage
                description="Login QR splash screen instruction item 3 notice"
                defaultMessage="You need to have an admin account to do this."
              />
            }
          />
        </Box>

        <Box
          space="large"
          style={{ width: "100%", flexShrink: 1, alignItems: "center" }}
        >
          <QRCode
            color={theme.darkerText}
            backgroundColor="transparent"
            ecl="H"
            value={"storeapp://storecast/add/" + props.userCode}
            size={sf * 190}
          />
        </Box>

        <Box spaceHorizontal="medium">
          <Box
            spaceVertical="small"
            spaceHorizontal="medium"
            cornerRadius="medium"
            style={{ backgroundColor: "#F4F3F9" }}
          >
            <AHText type="list-item-title">
              <FormattedMessage
                description="Login QR splash screen support info"
                defaultMessage="Contact us on"
              />
            </AHText>

            <AHText type="title-small" spaceTop="xsmall">
              +46&nbsp;10-147&nbsp;90&nbsp;11
            </AHText>
          </Box>
        </Box>
      </Box>
    </View>
  );
}
